import React from 'react'
import Layout from './layout'
import Row, { Slot } from './row'
import styles from '../component-styles/connect-analytics.module.scss'
import Button from './button'
import ConnectButton from './connect-button'

interface Props {
  title?: string
}

export default function ConnectAnalytics({
  title = 'How would you like to start?',
}: Props): React.ReactElement {
  return (
    <Layout width={688}>
      <Row align="center">
        <Slot align="center">
          <h1 className={styles.title}>{title}</h1>
        </Slot>
      </Row>
      <Row align="center">
        <Slot align="center">
          <p className={styles.para}>
            Each Uplifter account is connected to one Google Analytics view. If
            you have multiple views, we recommend connecting to your websites
            main view, excluding bot traffic.
          </p>
        </Slot>
      </Row>
      <Row align="center">
        <Slot align="center">
          <ConnectButton />
        </Slot>
      </Row>
      <Row align="center">
        <Slot align="center">
          <h2 className={styles.separatorTitle}>OR</h2>
        </Slot>
      </Row>
      <Row align="center">
        <Slot align="flex-end">
          <Button to="/select-module" type="bigGrey">
            Connect to Google Analytics Later
          </Button>
        </Slot>
      </Row>
    </Layout>
  )
}
